import React from 'react';
import type { ResumeData } from '../types';
import { formatDate } from '../utils';

export function CreativeTemplate({ data }: { data: ResumeData }) {
  return (
    <div className="max-w-4xl mx-auto bg-gradient-to-br from-purple-50 to-indigo-50 p-8">
      {/* Header */}
      <header className="text-center mb-12">
        <h1 className="text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600 mb-4">
          {data.personalInfo.fullName}
        </h1>
        <div className="flex flex-wrap justify-center gap-4 text-gray-600">
          <span>{data.personalInfo.email}</span>
          <span>•</span>
          <span>{data.personalInfo.phone}</span>
          <span>•</span>
          <span>{data.personalInfo.location}</span>
          {data.personalInfo.website && (
            <>
              <span>•</span>
              <span>{data.personalInfo.website}</span>
            </>
          )}
        </div>
      </header>

      {/* Experience */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold text-indigo-600 mb-6">Experience</h2>
        {data.experiences.map((exp) => (
          <div key={exp.id} className="mb-8 bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex flex-wrap justify-between items-baseline mb-2">
              <h3 className="text-xl font-semibold text-gray-900">{exp.position}</h3>
              <span className="text-sm text-indigo-600">
                {formatDate(exp.startDate)} - {exp.isCurrentJob ? 'Present' : formatDate(exp.endDate)}
              </span>
            </div>
            <h4 className="text-lg text-gray-700 mb-2">{exp.company}</h4>
            <p className="text-gray-600">{exp.description}</p>
          </div>
        ))}
      </section>

      {/* Education */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold text-indigo-600 mb-6">Education</h2>
        {data.education.map((edu) => (
          <div key={edu.id} className="mb-6 bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex flex-wrap justify-between items-baseline mb-2">
              <h3 className="text-xl font-semibold text-gray-900">{edu.degree}</h3>
              <span className="text-sm text-indigo-600">
                {formatDate(edu.startDate)} - {edu.isPursuing ? 'Present' : formatDate(edu.endDate)}
              </span>
            </div>
            <h4 className="text-lg text-gray-700">{edu.institution}</h4>
          </div>
        ))}
      </section>

      {/* Skills */}
      <section>
        <h2 className="text-2xl font-bold text-indigo-600 mb-6">Skills</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Technical Skills</h3>
            <p className="text-gray-600">{data.skills.technical}</p>
          </div>
          <div className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Soft Skills</h3>
            <p className="text-gray-600">{data.skills.soft}</p>
          </div>
        </div>
      </section>
    </div>
  );
}